import { render, staticRenderFns } from "./OperationPreviewRemittance.vue?vue&type=template&id=61677a45&scoped=true"
import script from "./OperationPreviewRemittance.vue?vue&type=script&lang=js"
export * from "./OperationPreviewRemittance.vue?vue&type=script&lang=js"
import style0 from "./OperationPreviewRemittance.vue?vue&type=style&index=0&id=61677a45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61677a45",
  null
  
)

export default component.exports